module.exports = __webpack_public_path__ + "static/media/N7.bee6923c.jpg";